<template>
  <div class="chart-unavailable">
    <p class="chart-unavailable__title">
      {{ $t('APPS.DASHBOARD.UNAVAILABLE_MESSAGE') }}
    </p>
    <p
      v-if="description"
      v-dompurify-html="description"
      class="chart-unavailable__description"
    />
  </div>
</template>

<script>
const descriptions = {
  purchases: 'APPS.DASHBOARD.NA_PURCHASE_MESSAGE',
};
export default {
  name: 'ChartUnavailable',
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    description() {
      const { name } = this.chartData;
      const translation = descriptions[name] || '';
      return this.$t(translation);
    },
  },
};
</script>

<style lang="scss">
.chart-unavailable {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $white;
  opacity: 0.95;

  &__title {
    font-weight: bold;
  }

  &__description {
    font-size: $small-font-size;
  }
}
</style>
